import Model, { attr } from '@ember-data/model';
import { service } from '@ember/service';
import type { Type } from '@warp-drive/core-types/symbols';
import type { PayloadType } from 'scaleflow/components/agents/form';
import { _labelExtract } from 'scaleflow/helpers/label-extract';
import type BetaToggleService from 'scaleflow/services/beta-toggle';

export default class AgentModel extends Model {
  declare [Type]: 'agent';
  @service declare betaToggle: BetaToggleService;

  @attr('string') declare name: string;
  @attr('string') declare provider: string;
  @attr('string') declare url: string;
  @attr declare config: Record<
    string,
    string | { key: string; value: string; payload: PayloadType }
  >;

  get providerLabel(): string {
    if (!this.provider) return '';
    const label = _labelExtract(
      this.betaToggle.agentProviderOptions,
      this.provider,
    );
    return label ? label : this.provider;
  }
}
